/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyOutName
 */
export interface PropertyOutName {
    /**
     * 
     * @type {string}
     * @memberof PropertyOutName
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof PropertyOutName
     */
    propertyId: number;
    /**
     * 
     * @type {Date}
     * @memberof PropertyOutName
     */
    modificationDate: Date;
}

export function PropertyOutNameFromJSON(json: any): PropertyOutName {
    return PropertyOutNameFromJSONTyped(json, false);
}

export function PropertyOutNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyOutName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'propertyId': json['propertyId'],
        'modificationDate': (new Date(json['modificationDate'])),
    };
}

export function PropertyOutNameToJSON(value?: PropertyOutName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'propertyId': value.propertyId,
        'modificationDate': (value.modificationDate.toISOString()),
    };
}


